<template>
  <div class="slds-form-element">
    <label class="slds-form-element__label" for="combobox-id-1">{{label}}</label>
    <div class="slds-form-element__control">

      <!-- Picklist -->
      <div v-if="mode === 'edit'" class="slds-combobox_container" :class="{'slds-has-selection': !!localValue}"  v-click-outside="{callback: closeEvent, enable: true}">
        <div class="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_click" :class="{'slds-is-open': open}" aria-expanded="false" aria-haspopup="listbox" role="combobox">
          <transition name="fade">
            <!-- No value selected -->
            <div class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none" v-if="!localValue">
              <input ref="input" :disabled="disabled" type="text" v-model="searchKey" class="slds-input slds-combobox__input" :id="`combobox-id-${id}`" :aria-controls="`listbox-id-${id}`" :readonly="disabled" autoComplete="off" role="textbox" :placeholder="placeholder" @click="toggleOpen" v-click-outside="{callback: closeEvent, enable: true}"/>
              <span class="slds-icon_container slds-icon-utility-down slds-input__icon slds-input__icon_right">
                <svg class="slds-icon slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                  <use xlink:href="../../assets/symbols.svg#search"></use>
                </svg>
              </span>
            </div>
            <!-- Value selected -->
            <div class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_left-right" role="none" v-else>
              <span class="slds-icon_container slds-icon-standard-campaign slds-combobox__input-entity-icon" title="Account">
                <svg class="slds-icon slds-icon_small" aria-hidden="true">
                  <use xlink:href="../../assets/symbols.svg#campaign"></use>
                </svg>
              </span>
              <input type="text" class="slds-input slds-combobox__input slds-combobox__input-value" id="combobox-id-5" aria-controls="listbox-id-5" autoComplete="off" role="textbox" readonly :value="selectedItem.name" />
              <button class="slds-button slds-button_icon slds-input__icon slds-input__icon_right" @click="setItem('')">
                <svg class="slds-button__icon" aria-hidden="true">
                  <use xlink:href="../../assets/symbols.svg#close"></use>
                </svg>
              </button>
            </div>
          </transition>
          <!-- Values -->
          <div :id="`listbox-id-${id}`" :class="`slds-dropdown_length-${visibleItems}`" class="slds-dropdown slds-dropdown_fluid" role="listbox" v-if="filteredList && filteredList.length">
            <ul class="slds-listbox slds-listbox_vertical" role="presentation">
              <li role="presentation" class="slds-listbox__item" v-for="(record, index) in filteredList" :key="index" @click="setItem(record.id)">
                <div id="option1" class="slds-media slds-listbox__option slds-listbox__option_entity slds-listbox__option_has-meta" role="option">
                  <span class="slds-media__figure slds-listbox__option-icon">
                    <span class="slds-icon_container slds-icon-standard-campaign" v-if="recordType === 'campaign'">
                      <svg class="slds-icon slds-icon-action-announcement" aria-hidden="true">
                        <use xlink:href="../../assets/symbols.svg#campaign"></use>
                      </svg>
                    </span>
                  </span>
                  <span class="slds-media__body">
                    <span class="slds-listbox__option-text slds-listbox__option-text_entity" v-html="$options.filters.highlight(record.name, searchKey)" />
                    <span class="slds-listbox__option-meta slds-listbox__option-meta_entity" v-if="record.description">
                      {{record.description.join(' • ')}}
                    </span>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else-if="selectedItem">
        <router-link :to="`${baseUrl}/${selectedItem.id}`" tag="a" class="lookup-link">
          {{selectedItem.name}}
        </router-link>
      </div>
      <div v-else>&nbsp;</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    baseUrl: {
      type: String,
      default: '',
      required: true
    },
    mode: {
      type: String,
      default: 'edit',
      required: false,
    },
    recordType: {
      type: String,
      default: '',
      required: true
    },
    value: {
      type: [String, Number],
      default: '',
      required: true
    },
    visibleItems: {
      type: Number,
      default: 7,
      required: false
    },
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    label: {
      type: String,
      default: '',
      required: true
    },
    records: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  created () {
    this.localValue = this.value
  },
  watch: {
    value (newValue) {
      this.localValue = newValue
    },
  },
  methods: {
    setItem (id) {
      this.$emit('input', id)
      this.open = false

      if (!id) {
        this.searchKey = ''
      }
    },
    isItemSelected (value) {
      return this.localValue === value
    },
    toggleItemSelection (option) {
      this.localValue = option

      this.$emit('input', this.localValue)
      this.searchKey = ''
      this.open = false
    },
    closeEvent () {
      if (this.open) {
        this.open = false
        this.searchKey = ''
      }
    },
    toggleOpen () {
      this.open = !this.open
    }
  },
  data () {
    return {
      id: parseInt(Math.random() * 999999),
      searchKey: '',
      open: false,
      localValue: {}
    }
  },
  computed: {
    filteredList () {
      return this.records.filter(option => option.name.toLowerCase().includes(this.searchKey.toLowerCase()))
    },
    selectedItem () {
      if (this.localValue) {
        return this.filteredList.find(item => item.id == this.localValue)
      } else {
        return null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .lookup-link {
    border-bottom: 1px dotted;
    text-decoration: none;
    display: inline-block;
    vertical-align: middle;
  }
</style>
